import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js';
// import 'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'

export default {
  mixins: [localeMixin],
  data: function data() {
    return {
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      about: {
        sysName: '',
        sysIcon: '',
        sysImage: '',
        sysRecord: ''
      } // 表单
      ,
      formLogin: {
        username: '',
        password: ''
      } // 表单校验
      ,
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      sys_login_logo: '',
      activeName: 'password',
      wechatLogin: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    // 计时器
    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
    // 加载一些基础系统信息
    this.aboutCacheValues({
      codes: 'sys_name,sys_record'
    }).then(function (res) {
      // 网站备案号
      _this.about.sysRecord = res.data.sys_record;
    });
    this.getSwitch();
    this.getLogo();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  watch: {
    activeName: function activeName(to) {
      if (to) {
        this.get_wx_qrcode();
      }
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('d2admin/account', ['loginByAccountAndPassword'])), mapActions('d2admin/about', ['aboutCacheValues'])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    } // 提交表单
    ,
    submit: function submit() {
      var _this2 = this;
      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (valid) {
                  // 登录
                  _this2.loginByAccountAndPassword({
                    account: _this2.formLogin.username,
                    password: _this2.formLogin.password
                  }).then(function () {
                    // 重定向对象不存在则返回顶层路径
                    _this2.$router.replace(_this2.$route.query.redirect || '/');
                  });
                } else {
                  // 登录表单校验失败
                  _this2.$message.error('信息校验失败，请检查');
                }
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    } // 获取logo
    ,
    getLogo: function getLogo() {
      var _this3 = this;
      this.$api['mngAboutCacheValues']('sys_login_logo').then(function (res) {
        if (res.data) {
          _this3.sys_login_logo = res.data.sys_login_logo || '';
        }
      });
    },
    getSwitch: function getSwitch() {
      var _this4 = this;
      this.$api['mngSwitchCacheValue']('Mng_Wechat_Qrcode_Login').then(function (res) {
        if (res.data) {
          _this4.wechatLogin = res.data;
        }
        _this4.getAppID();
      });
    },
    getAppID: function getAppID() {
      var _this5 = this;
      this.$api['mngConfigCacheValues']('wx_web_appid,wx_web_login_callback_url').then(function (res) {
        if (res.data) {
          _this5.wx_web_appid = res.data.wx_web_appid;
          _this5.wx_web_login_callback_url = res.data.wx_web_login_callback_url;
          localStorage.setItem('wx_web_login_callback_url', res.data.wx_web_login_callback_url);
        } else {
          _this5.$message.error(res.msg);
        }
      });
    },
    get_wx_qrcode: function get_wx_qrcode() {
      var href = this.wx_web_login_callback_url + '#/login_code';
      var obj = new WxLogin({
        self_redirect: true,
        id: 'code-container' // 需要承载二维码的容器id
        ,
        appid: this.wx_web_appid,
        scope: 'snsapi_login' // 网页授权，目前网页只有这一种方式，静默授权
        ,
        redirect_uri: encodeURIComponent(href) // 回调域名
        ,
        state: Math.random(),
        style: 'white',
        href: 'data:text/css;base64,LmltcG93ZXJCb3gge3dpZHRoOiAyMzhweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAxNjVweDttYXJnaW4tdG9wOiAwcHg7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDEwMCU7Y29sb3I6IzAwMH0KLnN0YXR1c19pY29uIHtkaXNwbGF5OiBub25lfQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ==' // 二维码样式代码base64加密
      });
    },
    handleClick: function handleClick(tab, event) {
      if (tab.index === 1) {
        this.getAppID();
      }
    }
  })
};